import { useState } from "react";
import "./Notifications.css";

function NotificationItem({ notification, onClick }) {
    const {
        date,
        topic,
        description,
        isRead,
    } = notification;

    const [open, setOpen] = useState(false);

    const formattedDate = new Intl.DateTimeFormat("pt-PT").format(new Date(date))

    return (
        <article className="notification-item" >
            <time className="notification-item__date">
                {formattedDate}
            </time>

            <h3 className="notification-item__title" onClick={() => {
                setOpen(!open);
                onClick();
            }}>
                {topic}
            </h3>
            {open && (
                description && (
                    <p className="notification-item__description">
                        {description}
                    </p>
                )
            )}
            {!isRead && (
                <span className="notification-item__badge">
                    Nova
                </span>
            )}
        </article>
    );
}

export default NotificationItem;